// extracted by mini-css-extract-plugin
export default {"component":"InLVTy","mobile":"WPKl8m","message":"c94dHw","action":"_jzuO1"};